import { useEffect } from 'react';
import axios from 'axios';
import { baseRESTUrl } from 'lib/utils';

export const UserList = () => {
  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`${baseRESTUrl()}/v1/user/userlist`, { withCredentials: true });

        const tag = document.createElement('script');
        tag.async = true;
        tag.src = 'https://js.userlist.com/v1';
        tag.setAttribute('data-userlist', response.data.token);
        
        const body = document.getElementsByTagName('body')[0];
        body.appendChild(tag);
      } 
      catch (e) {}
    })();
  }, []);

  return (
    <script dangerouslySetInnerHTML={{ __html: `window.userlist=window.userlist||function(){(userlist.q=userlist.q||[]).push(arguments)};` }}></script>
  );
};